var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._b({staticClass:"common-button",class:[
      'common-button-'+ _vm.type,
      'common-button-'+ _vm.size,
      'common-button-'+ _vm.image
  ],attrs:{"type":"button"},on:{"click":_vm.handleClick}},'button',_vm.$attrs,false),[(_vm.$slots.default)?_c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f9e2726","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/CommonButton.vue
// module id = null
// module chunks = 